import {createAction, props} from '@ngrx/store';
import {AuthenticateEvent} from './event.interface';

export const registerAnother = createAction('[Event] Register another person');

export const continueToCheckout = createAction('[Event] Continue to checkout');

export const cartLoad = createAction('[Event] Cart Load');

export const cartUpdate = createAction('[Event] Cart Update');

export const authenticate = createAction(
  '[Event] Authenticate',
  props<AuthenticateEvent>(),
);
